import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import styles from "./render-unreleased-features.module.scss";

interface RenderUnreleasedFeaturesProps {
  children: ReactNode;
}

const cssClassName = "render-unreleased-features";

export const RenderUnreleasedFeatures = ({
  children,
}: RenderUnreleasedFeaturesProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const showRenderUnreleasedFeaturesStyle = useSelector(
    (state: RootState) => state.yourSlice.showRenderUnreleasedFeaturesStyle,
  );

  const permissionName = "view-unreleased-features";
  const [userIsAllowed, setUserIsAllowed] = useState<boolean>(false);

  useEffect(() => {
    if (authContext) {
      setUserIsAllowed(authContext.permissions.includes(permissionName));
    }
  }, [authContext]);

  if (userIsAllowed === null) return null;

  return (
    <>
      {userIsAllowed && (
        <>
          {showRenderUnreleasedFeaturesStyle ? (
            <div className={styles[cssClassName]}>{children}</div>
          ) : (
            <>{children}</>
          )}
        </>
      )}
    </>
  );
};
